export default {
  mobilityOption: "MobilityOption",
  AddMobilityOption: "AddMobilityOption",
  editMobilityOption: "EditMobilityOption",
};
